export const toggleValueIntoArray = (array: any[], value: any) => {
  const isAvailable = array.includes(value);
  if (isAvailable) {
    return array.filter((item) => item !== value);
  } else {
    return [...array, value];
  }
};
export const isArraysEqual = <T>(array1: T[], array2: T[]): boolean => {
  if (array1.length !== array2.length) {
    return false;
  }

  const set1 = new Set(array1);
  const set2 = new Set(array2);

  if (set1.size !== set2.size) {
    return false;
  }

  for (const item of Array.from(set1)) {
    if (!set2.has(item)) {
      return false;
    }
  }

  return true;
};

// TODO: add unit test
export const createSequentialArray = <N extends number>(n: N) => {
  const createdArray = Array.from(
    { length: n },
    (_, index) => index + 1
  ) as Tuple<number, N>;

  return createdArray;
};

/**
 * Sort an array of objects by a numeric property in descending order
 * @param array The array to sort
 * @param property The property to sort by
 * @returns The sorted array
 */
export const sortByNumberPropertyDesc = <T>(
  array: T[],
  property: keyof T
): T[] => {
  return [...array].sort((a, b) => {
    const aValue = a[property] as unknown as number;
    const bValue = b[property] as unknown as number;
    return bValue - aValue;
  });
};

/**
 * Sort an array of objects by a numeric property in ascending order
 * @param array The array to sort
 * @param property The property to sort by
 * @returns The sorted array
 */
export const sortByNumberPropertyAsc = <T>(
  array: T[],
  property: keyof T
): T[] => {
  return [...array].sort((a, b) => {
    const aValue = a[property] as unknown as number;
    const bValue = b[property] as unknown as number;
    return aValue - bValue;
  });
};

/**
 * Sort an array of objects by a numeric property with specified order direction
 * @param array The array to sort
 * @param property The property to sort by
 * @param direction The sort direction ('asc' or 'desc')
 * @returns The sorted array
 */
export const sortByNumberProperty = <T>(
  array: T[],
  property: keyof T,
  direction: 'asc' | 'desc' = 'asc'
): T[] => {
  return direction === 'desc'
    ? sortByNumberPropertyDesc(array, property)
    : sortByNumberPropertyAsc(array, property);
};
